import * as amplitude from "@amplitude/analytics-browser";

const { VITE_ENVIRONMENT, VITE_AMPLITUDE_API_KEY } = import.meta.env;

const initAmplitude = () => {
  console.log("Amplitude initialized");

  amplitude.init(VITE_AMPLITUDE_API_KEY, undefined, {
    logLevel:
      VITE_ENVIRONMENT === "development"
        ? amplitude.Types.LogLevel.Warn
        : amplitude.Types.LogLevel.Warn,
    defaultTracking: {
      sessions: true,
      pageViews: {
        trackHistoryChanges: "pathOnly",
      },
      formInteractions: true,
      fileDownloads: true,
    },
  });
};

const disableAmplitudeTracking = () => {
  amplitude.setOptOut(true);
};

export const handleConsentChangeForAmplitude = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.analytics;
  const noCmp = !window.getCkyConsent;

  if (noCmp) {
    console.log("No CMP found");
  }

  if (consentViaCookieYes) {
    initAmplitude(); // enable when turning on CookieYes
  } else {
    disableAmplitudeTracking(); // enable when turning on CookieYes
  }
};
